import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import FormAddPartner from './FormAddPartner';
import ListPartner from './ListPartner';

const Partner = (props) => {
  const { match } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListPartner match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route path={`${match.url}/add-partner`} component={FormAddPartner} />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/edit-partner/:part_id`}
            component={FormAddPartner}
          />
        )}
      </Switch>
    </div>
  );
};

export default Partner;
